import React from 'react'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import { Typography } from '@material-ui/core'
import { ReactComponent as RadioInvertedCheck } from '../../../../../assests/icons/RadioInvertedCheck.svg'
// import { Router } from 'express'

const SelectLanguage = ({ value}) => {
    return (
        <div className="booking_boxes">
            <div>
                <Typography className="step-headers">
                    Select your language preference.
                </Typography>
            </div>
            <FormControl className="card-raw">
                <RadioGroup
                    value={value}
                    // onChange={(event) => setValue(event.target.value)}
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    className="booking_radio_group">
                    <FormControlLabel
                        className="booking_box"
                        value="en"
                        onClick={() => {
                            const lang ='en'
                            if (lang) { 
                                const newHash = `#googtrans(en|${lang})`; 
                                if (window.location.hash !== newHash) { 
                                    window.location.hash = newHash; 
                                    window.location.reload(); 
                            } };
                        }}
                        control={
                            <Radio
                                checkedIcon={<RadioInvertedCheck />}
                                className="first_time_booking_radio"
                            />
                        }
                        label="English"
                    />
                    <FormControlLabel
                        className="booking_box"
                        value="es"
                        onClick={() => {
                            const lang ='es'
                            if (lang) { 
                                const newHash = `#googtrans(en|${lang})`; 
                                if (window.location.hash !== newHash) { 
                                    window.location.hash = newHash; 
                                    window.location.reload(); 
                            } };
                        }}
                        control={
                            <Radio
                                checkedIcon={<RadioInvertedCheck />}
                                className="first_time_booking_radio"
                            />
                        }
                        label="Español"
                    />
                    
                    {/* <FormControlLabel
                        className="booking_box"
                        value="ar"
                        onClick={() => {
                            const lang ='ar'
                            if (lang) { 
                                const newHash = `#googtrans(en|${lang})`; 
                                if (window.location.hash !== newHash) { 
                                    window.location.hash = newHash; 
                                    window.location.reload(); 
                            } };
                        }}
                        control={
                            <Radio
                                checkedIcon={<RadioInvertedCheck />}
                                className="first_time_booking_radio"
                            />
                        }
                        label="Arabic"
                    />
                    <FormControlLabel
                        className="booking_box"
                        value="zh-CN"
                        onClick={() => {
                            const lang ='zh-CN'
                            if (lang) { 
                                const newHash = `#googtrans(en|${lang})`; 
                                if (window.location.hash !== newHash) { 
                                    window.location.hash = newHash; 
                                    window.location.reload(); 
                            } };
                        }}
                        control={
                            <Radio
                                checkedIcon={<RadioInvertedCheck />}
                                className="first_time_booking_radio"
                            />
                        }
                        label="Chinese"
                    />
                    <FormControlLabel
                        className="booking_box"
                        value="ko"
                        onClick={() => {
                            const lang ='ko'
                            if (lang) { 
                                const newHash = `#googtrans(en|${lang})`; 
                                if (window.location.hash !== newHash) { 
                                    window.location.hash = newHash; 
                                    window.location.reload(); 
                            } };
                        }}
                        control={
                            <Radio
                                checkedIcon={<RadioInvertedCheck />}
                                className="first_time_booking_radio"
                            />
                        }
                        label="Korean"
                    />
                    <FormControlLabel
                        className="booking_box"
                        value="fa"
                        onClick={() => {
                            const lang ='fa'
                            if (lang) { 
                                const newHash = `#googtrans(en|${lang})`; 
                                if (window.location.hash !== newHash) { 
                                    window.location.hash = newHash; 
                                    window.location.reload(); 
                            } };
                        }}
                        control={
                            <Radio
                                checkedIcon={<RadioInvertedCheck />}
                                className="first_time_booking_radio"
                            />
                        }
                        label="Persian"
                    />
                    <FormControlLabel
                        className="booking_box"
                        value="vi"
                        onClick={() => {
                            const lang ='vi'
                            if (lang) { 
                                const newHash = `#googtrans(en|${lang})`; 
                                if (window.location.hash !== newHash) { 
                                    window.location.hash = newHash; 
                                    window.location.reload(); 
                            } };
                        }}
                        control={
                            <Radio
                                checkedIcon={<RadioInvertedCheck />}
                                className="first_time_booking_radio"
                            />
                        }
                        label="Vietnamese"
                    /> */}
                </RadioGroup>
                
            </FormControl>
        </div>
    )
}

export default SelectLanguage
